$.fn.scrollTo = function (speed) {
  if (typeof(speed) === 'undefined')
      speed = 1000;

  $('html, body').animate({
      scrollTop: parseInt($(this).offset().top)
  }, speed);
};

(function($) {
  //   //  sticky navigation
  var stickyNavBar = $("div.navbar");
  var stickyNavTop = stickyNavBar.offset().top + 100;
  const pageHeader = document.getElementById("pageHeader");

  function stickyNav() {
    if (window.pageYOffset > stickyNavTop) {
      pageHeader.classList.add("sticky");
    } else {
      pageHeader.classList.remove("sticky");
    }
  }

  //  replace links
  stickyNavBar.find("li a").each(function(index){
    const href = $(this).attr('href');
    if (href.substring(0, 1) === "#") {
      $(this).attr('href', '/' + href);
    }
  });

  if ($("html.no-touchevents").length) {
    window.onscroll = function() {
      stickyNav();

      const windowScrollTop = window.pageYOffset;
      const stickyNavBarHeight = stickyNavBar.height();
      var anyActive = false;

      $("a.target").each(function() {
        const parentOffset = $(this)
          .parent()
          .offset().top;
        if (windowScrollTop + stickyNavBarHeight >= parentOffset) {
          var id = $(this).attr("name");
          $("nav a").removeClass("active");
          $('nav a[href="#' + id + '"]').addClass("active");
          anyActive = true;
        }
      });

      if (!anyActive) {
        $("nav a").removeClass("active");
      }
    };

    //  nav scroll on click
    stickyNavBar.find("li a").on("click", function(e) {
      const href = $(this).attr("href");
      const targetString = `a[name=${href.replace(/[#\/]+/, "")}]`;

      if (href.match(/^\/?#/) && $(targetString).length > 0) {
        e.preventDefault();
        $(targetString).scrollTo(300);
      }
    });

    stickyNav();
  }
})(jQuery);
